import i18next from "i18next";

const bilingual = (lang) => {
  return i18next.init({
    lng: lang,
    resources: {
      en: {
        translation: {
          HardFileRequired: "Hardcopy must be submitted to FHI",
          ReclaimInfo: "Success reSubmit Claim",
          Yes: "Yes",
          No: "No",
          Back: "Back",
          SubmitInvoice: "Submit Invoice",
          InvoiceNumber: "Invoice Number",
          InvoiceBy: "Invoice By",
          InvoiceDate: "Invoice Date",
          Amount: "Amount",
          WarningCreateInv: "Please select a claim before creating an invoice.",
          Search: "Search",
          CardNumber: "Card Number",
          ClaimNumber: "Claim Number",
          ClaimStatus: "Claim Status",
          AdmissionDate: "Admission Date",
          PatientName: "Patient Name",
          VisitType: "Visit Type",
          TotalClaim: "Total Claim",
          CreateInvoice: "Create Invoice",
          CreateInvoiceDesc:
            "Create a new invoice by entering the details below",
          Reload: "Reload",
          Delete: "Delete",
          DocSup: "Dokumen Pendukung",
          Uploadedfiles: "Uploaded files",
          Dragdropfiles: "Drag and drop your files here, only PDF allowed.",
          MaxFile: "Max file size: 50MB",
          NoFileUp: "No files uploaded yet",
          PaymentDate: "Payment Date",
          AmountSubmitted: "Amount Submitted",
          BenefitPaid: "Benefit Paid",
          ExcessCharge: "Excess Amount",
          PatientPaid: "Patient Paid",
          Ok: "Ok",
          Cancel: "Cancel",
          deleteFile: "Do you want to delete this document?",
          deleteClaim: "Do you want to delete this claim?",
          deleteFileDesc: "This document will be permanently removed.",
          deleteClaimDesc: "This claim will be removed from your list",
          Confirmation: "Confirmation",
          ConfirmCancelInvoice:
            "Are you sure cancel create invoice?, data invoice will be lost",
          "Upload File": "Upload File",
          WarningCreate:
            "All claims must have at least one file before creating the invoice !",
          NoclaimFound: "No claim found",
          ClaimNo: "Claim No.",
          NotifNew: "New Notifications",
          ShowAll: "Show All",
          DeleteAllClaim: "Do you want to delete all claims?",
          PleaseEnterInv: "Please enter invoice number.",
          PlaceHolderInv: "Enter invoice number (e.g., INV-2025-001)",
          AddClaim: "Add Claim",
          IndentifyInv: "Unique invoice identifier",
          ClaimWithFile: "Claim With File",
          ClaimWithoutFile: "Claim Without File",
          DelAllClaim: "Delete All Claim",
          NoClaimAvailable: "No Claim Available",
          Add: "Add",
          Close: "Close",
          SelectTypeClaim: "Select Type Claim",
          SearchClaimToInv: "Search for a claim to add an invoice",
          DetailClaim: "Claim Details",
          ListOfClaim: "Claim List",
          Remark: "Remark",
          Reason: "Reason",
          ShowDetails: "Show Details",
          HideDetails: "Hide Details",
          Resubmit: "Resubmit",
          searchMemberBy: "Search Member By",
          TraceNumber: "Trace Number",
          EmployeeID: "Employee ID",
        },
      },
      id: {
        translation: {
          HardFileRequired: "Hardcopy wajib dikirim ke FHI",
          ReclaimInfo: "Berhasil ajukan ulang claim",
          Yes: "Ya",
          No: "Tidak",
          Back: "Kembali",
          SubmitInvoice: "Kirim Invoice",
          InvoiceNumber: "Nomor Invoice",
          InvoiceBy: "Dibuat Oleh",
          InvoiceDate: "Tanggal Invoice",
          Amount: "Jumlah",
          WarningCreateInv: "Mohon pilih klaim dulu sebelum membuat invoice.",
          Search: "Cari",
          CardNumber: "Nomor Kartu",
          ClaimNumber: "Nomor Claim",
          ClaimStatus: "Status Klaim",
          AdmissionDate: "Tanggal Masuk Rawat",
          PatientName: "Nama Pasien",
          VisitType: "Jenis Kunjungan",
          TotalClaim: "Jumlah Claim",
          CreateInvoice: "Buat Invoice",
          CreateInvoiceDesc:
            "Buat invoice baru dengan mengisi detail di bawah ini",
          Reload: "Muat Ulang",
          Delete: "Hapus",
          DocSup: "Supporting Document",
          Uploadedfiles: "File yang diunggah ",
          Dragdropfiles:
            "Letakkan file Anda di sini, hanya file PDF yang diperbolehkan",
          MaxFile: "Ukuran file maksimal: 50MB",
          NoFileUp: "tidak ada file",
          PaymentDate: "Tanggal Pembayaran",
          AmountSubmitted: "Jumlah yang Diajukan",
          BenefitPaid: "Jumlah Manfaat yang Dibayarkan",
          ExcessCharge: "Jumlah Kelebihan Biaya",
          PatientPaid: "Jumlah yang Dibayar Pasien",
          Ok: "Oke",
          Cancel: "Batal",
          deleteFile: "Apakah Anda ingin menghapus dokumen ini?",
          deleteClaim: "Apakah Anda ingin menghapus klaim ini?",
          deleteFileDesc: "Dokumen ini akan dihapus secara permanen.",
          deleteClaimDesc: "Klaim ini akan dihapus dari daftar Anda",
          Confirmation: "Konfirmasi",
          ConfirmCancelInvoice:
            "Apakah Anda ingin batalkan pembuatan invoice? Data yang sudah dimasukkan akan hilang.",
          "Upload File": "Unggah Dokumen",
          WarningCreate:
            "Semua klaim harus memiliki minimal satu file sebelum membuat invoice!",
          NoclaimFound: "No claim found",
          ClaimNo: "No. Klaim",
          NotifNew: "Notifikasi Baru",
          ShowAll: "Tampilkan Semua",
          DeleteAllClaim: "Apakah Anda ingin menghapus semua klaim ?",
          PleaseEnterInv: "Silakan masukkan nomor invoice.",
          PlaceHolderInv: "Masukkan nomor invoice (contoh: INV-2025-001)",
          AddClaim: "Tambah Klaim",
          IndentifyInv: "Kode unik invoice",
          ClaimWithFile: "Klaim dengan File",
          ClaimWithoutFile: "Klaim Tanpa file",
          DelAllClaim: "Hapus Semua Klaim",
          NoClaimAvailable: "Tidak Ada Klaim Tersedia",
          Add: "Tambahkan",
          Close: "Tutup",
          SelectTypeClaim: "Pilih Type Klaim",
          SearchClaimToInv: "Cari klaim untuk menambahkan invoice",
          DetailClaim: "Detail Klaim",
          ListOfClaim: "Daftar Klaim",
          Remark: "Catatan",
          Reason: "Keterangan",
          ShowDetails: "Tampilkan Detail",
          HideDetails: "Sembunyikan Detail",
          Resubmit: "Ajukan ulang",
          searchMemberBy: "Cari Peserta Berdasarkan",
          TraceNumber: "Nomor Trace",
          EmployeeID: "ID Peserta",
        },
      },
    },
  });
};

export default bilingual;
